'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var preferredLanguage = navigator.languages ? navigator.languages[0] : navigator.language;

var defaultLanguage = exports.defaultLanguage = preferredLanguage ? preferredLanguage.toLowerCase() : 'en-us';